import aimLogo from "../../assets/aim.png";
import back from "../../assets/back.png";
import backHover from "../../assets/backHover.png";
import topScores from "../../assets/top_scores.png";
import topScoresHover from "../../assets/top_scoresHover.png";
import { Link } from "react-router-dom";

const PrecisionNavBar = (props) => {
  return (
    <div
      style={{ height: props.height, width: props.width }}
      className="d-flex justify-content-between align-items-center px-5"
    >
      <div
        className="d-flex justify-content-left align-items-center"
        style={{ fontSize: "x-large", fontWeight: "700", color: "white" }}
      >
        <a href="https://aimtrainer.com/" target={"_blank"} rel="noreferrer">
          <img
            src={aimLogo}
            height={50}
            width={130}
            className="mr-3 nav-bar-logo"
            alt="aimLogo"
          />
        </a>
      </div>
      <div
        className="back-button d-flex justify-content-right align-items-center"
        style={{
          width: "max-content",
        }}
      >
        <Link to={`/precision-scores`}>
          <img
            className="mr-3"
            width={130}
            height={40}
            src={topScores}
            onMouseOver={(e) => {
              e.currentTarget.src = topScoresHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = topScores;
            }}
            alt="back"
          ></img>
        </Link>
        <Link to={`/aimtrainer/`}>
          <img
            width={130}
            height={40}
            src={back}
            onMouseOver={(e) => {
              e.currentTarget.src = backHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = back;
            }}
            alt="back"
          ></img>
        </Link>
      </div>
    </div>
  );
};

export default PrecisionNavBar;
